<template>
  <v-app>
    <div></div>
    <div class="appMain container-fluid">
      <router-view />
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  })
};
</script>

<style>
.appMain {
  display: flex;
  justify-content: flex-start;
  padding: 1rem;
}

.home {
  padding: 0 1rem;
  width: 100%;
}

.info-heading,
.info-card {
  display: flex;
  justify-content: space-between;
}

.info-card {
  padding: 1rem;
  margin: 1rem 0;
}

.entry-container {
  padding: 1rem;
}

::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

::-moz-calendar-picker-indicator {
  filter: invert(1);
}

.btn-main {
  margin: 0.2rem;
}

@media only screen and (max-width: 800px) {
  html {
    font-size: 62.5%;
  }
}
</style>
<style lang="scss">
// @import "assets/scss/index";
// @import "~bootstrap/scss/bootstrap";
// @import "~bootstrap-vue/src/index.scss";
@import "~vue-cal/dist/vuecal.css";
</style>
